import $ from 'jquery';

import App from 'libs/app';
import 'libs/jquery.doubleScroll';

App.registerReadyHandler("table-scrollable", function () {
    $(".table-scrollable:not([data-table-to-dropdown]), form[id^='users_'] table, form[id^='groups_'] table").wrap($("<div/>").addClass("scroll-wrapper"));
    let $scrollWrapper = $("div.scroll-wrapper");
    if ($scrollWrapper.length > 0)
        $scrollWrapper.doubleScroll({
            resetOnWindowResize: true // recompute the top ScrollBar requirements when the window is resized
        });
});